import { MaskLine } from "./Reveal";
import { motion } from "framer-motion";

export const PageHero = ({ eyebrow, title, subtitle }) => {
  return (
    <section data-testid="page-hero" className="relative overflow-hidden bg-fc-navy text-white pt-20 pb-20 lg:pt-24 lg:pb-24">
      <div className="absolute inset-0 z-0" style={{ background: "radial-gradient(circle at 84% 18%, rgba(47,164,231,0.18), transparent 45%), radial-gradient(circle at 6% 95%, rgba(245,130,31,0.14), transparent 45%), linear-gradient(125deg,#081F44 0%,#0B2C5C 60%,#0f3f78 100%)" }} />
      <div className="absolute inset-0 z-0 opacity-[0.14]" style={{ backgroundImage: "linear-gradient(rgba(255,255,255,0.5) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.5) 1px, transparent 1px)", backgroundSize: "90px 90px" }} />
      <div className="relative z-10 mx-auto w-[92%] max-w-[1280px]">
        <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 0.15 }} className="font-mono text-[11px] uppercase tracking-[0.25em] text-fc-cyan mb-6">
          {eyebrow}
        </motion.div>
        <h1 className="font-display font-semibold tracking-tighter leading-[0.92] text-[12vw] sm:text-6xl lg:text-7xl max-w-4xl">
          <MaskLine delay={0.25}>{title}</MaskLine>
        </h1>
        {subtitle && (
          <motion.p initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.55, duration: 0.8 }} className="mt-6 max-w-xl text-white/65 text-lg">
            {subtitle}
          </motion.p>
        )}
      </div>
    </section>
  );
};
